import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'debitoGrupo'
})
export class DebitoGrupoPipe implements PipeTransform {

  transform(value: any): any {
    if(value == '1'){
      value = 'Si';
    }else if(value == '0'){
      value = 'No';
    }else{
      value = 'N/A';
    }
    return value;
  }

}
